import { flatten } from 'ramda';

export type ClassValue =
  | string
  | number
  | ClassArray
  | undefined
  | null
  | false;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ClassArray extends Array<ClassValue> {}

const classNames = (className: ClassValue): string | void => {
  const classes = className instanceof Array ? className : [className];
  const classStr = flatten(classes).filter(Boolean).join(' ');
  return classStr === '' ? undefined : classStr;
};

export default classNames;
